import {useEffect, useRef} from 'react';

import HomeFooter from '@/components/features/home/HomeRoot/HomeFooter';
import CookieMessages from '@/components/global/banners/CookieMessages';
import SystemMessage from '@/components/global/banners/SystemMessage';
import AppBar from '@/components/global/layout/AppBar';
import SelfServiceReportingModal from '@/components/global/modals/SelfServiceReportingModal/SelfServiceReportingModal';
import EppoFlags from '@/EppoFlags';
import {useStringAssignmentExperimentDetails} from '@/eppoHooks';
import ContactUsPageContent from './ContactUsPageContent';
import HelpPageContent from './HelpPageContent';

const ContactUsPageRoot: React.FC<unknown> = () => {
  const {variation, trackExperimentExposed} = useStringAssignmentExperimentDetails(
    EppoFlags.IntercomHelpCenter,
  );
  const hasTrackedExposureRef = useRef(false);

  useEffect(() => {
    if (hasTrackedExposureRef.current || variation === 'fallback') return;
    hasTrackedExposureRef.current = true;

    trackExperimentExposed();
  }, [variation, trackExperimentExposed]);

  return (
    <>
      <AppBar />
      <SelfServiceReportingModal />
      <SystemMessage shouldShowTitle={false} />
      <CookieMessages />

      <main className="min-h-screen bg-white text-peppercorn-800">
        {variation === 'treatment' ? (
          <HelpPageContent experimentVariation={variation} />
        ) : (
          <ContactUsPageContent experimentVariation={variation} />
        )}
      </main>

      <HomeFooter />
    </>
  );
};

export default ContactUsPageRoot;
